<template>
    <div class="row justify-content-center align-items-md-center">
      <div class="col-md-8">
       <v-card elevation="8">
          <v-card-title class="card-header">
            <h3 class="mb-0">Tipo Protocolo</h3></v-card-title
          >
          <div class="card-body">
            <b-table
              :fields="['nome', 'descricao', 'acoes']"
              :items="lista_tipo_protocolo"
              :per-page="perPage"
              :current-page="currentPage"
              id="filiais-table"
              class="
                table
                table-head-custom
                table-vertical-center
                table-head-bg
                table-borderless
              "
              show-empty
              empty-text="Nenhum registro encontrado!"
            >
             
              <template #head(acoes)><span></span></template>
              <template #cell(acoes)="{ item }">
                <div class="text-right w-100">
                  <v-tooltip
                    v-for="(btn, index) in lista_btn"
                    :key="index"
                    top
                    :color="btn.color"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                       v-show="lista_permissoes_filial[btn.permisao]"
                        fab
                        outlined
                        class="mr-1"
                        @click="acoes(item, btn.button)"
                        :color="btn.color"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <i :class="btn.icon"></i>
                      </v-btn>
                    </template>
                    <span>{{ btn.title }}</span>
                  </v-tooltip>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="lista_tipo_protocolo.length"
              :per-page="perPage"
              aria-controls="filiais-table"
            >
            </b-pagination>
          </div>
       </v-card>
      </div>
    </div>
  
  </template>
  
  
  
  <script>
  import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
  import moneyFormat from "@/core/mixins/moneyFormat";
  import { fireAlert } from "@/core/mixins/alertMessageMixin";
  
  export default {
    mixins: [moneyFormat, fireAlert],
  
    data() {
      return {
        currentPage: 1,
        perPage: 10,
        lista_btn: [
           
          {
            permisao:"u_TipoProtocolo",
            button: "editar",
            title: "Editar registro",
            color: "primary",
            icon: "far fa-edit text-primary",
          },
          {
            permisao:"lock_TipoProtocolo",
            button: "exclusao",
            title: "Bloquear/Desbloquear registro",
            color: "error",
            icon: "fas fa-unlock-alt text-danger",
          },
        ],
      
      };
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Tipo Protocolo" }]);
    },
    computed: {
      lista_tipo_protocolo() {
        return this.$store.state.tipoProtocolo.lista_tipo_protocolo;
      },
      lista_permissoes_filial() {
        return this.$store.state.sistema.lista_permissoes_filial;
      },  
       mensagem_alert() {
        return this.$store.state.tipoProtocolo.mensagem_alert;
      },
    },
    created() {
      this.listar_tipo_protocolo();
    },
    methods: {
      acoes(item, tipo) {
        if (tipo == "editar") this.atualizar(item);
        if (tipo == "exclusao") this.confirm(item);
      },
      async listar_tipo_protocolo() {
        await this.$store.dispatch("tipoProtocolo/listar_tipo_protocolo");
        this.$store.dispatch("configEmpresa/atualizar", "");
      },
      atualizar(value) {
        this.$router.push({ name: "createTipoProtocolo" });
        this.$store.dispatch("configEmpresa/atualizar", value);
      },
      async confirm(value) {
      await this.$confirm({
        title: "Tem Certeza?",
        message: `Esta ação faz Exclusao desse Tipo Protocolo no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.bloquear(value);
          }
        },
      });
    },
    async bloquear(value) {
      await this.$store.dispatch("tipoProtocolo/delete_tipo_protocolo", value);
      this.fireAlert({
          ...this.mensagem_alert
        });
    },
 
    
    },
  };
  </script>
  
  <style scoped>
  .lista:hover {
    background-color: rgba(167, 183, 255, 0.705);
  }
  </style>